import {
  SHARED_CONTINUITY_ROOM_DEFAULT_SLUG,
  SHARED_CONTINUITY_ROOM_PRODUCT_HOST_PRIMARY,
} from "./shared_continuity_room_hosts";

export { SHARED_CONTINUITY_ROOM_DEFAULT_SLUG } from "./shared_continuity_room_hosts";

/**
 * Normalizes a user-supplied room slug for path segments and storage keys.
 * Lowercase, hyphenated, length-capped; drops unsafe characters.
 */
export function sanitizeSharedContinuityRoomSlug(raw: string | null | undefined): string {
  const s = String(raw ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
  return s.slice(0, 48);
}

export type BuildSharedContinuityRoomUrlInput = {
  roomSlug: string;
  /**
   * Hostname for the absolute URL. Defaults to `room.xo-vault.com`.
   * Pass `rooms.xo-vault.com` (or `www.` variants) to build fallback-host links; paths remain `/<slug>`.
   */
  host?: string;
  /** Default `https` */
  protocol?: string;
};

/**
 * Canonical public URL for a room on the dedicated product host: `https://room.xo-vault.com/<slug>`.
 */
export function buildSharedContinuityRoomUrl(input: BuildSharedContinuityRoomUrlInput): string {
  const slug = sanitizeSharedContinuityRoomSlug(input.roomSlug) || SHARED_CONTINUITY_ROOM_DEFAULT_SLUG;
  const protoRaw = String(input.protocol ?? "https").trim();
  const proto = protoRaw.endsWith(":") ? protoRaw : `${protoRaw}:`;
  const hostRaw = String(input.host ?? "").trim().toLowerCase();
  const safeHost =
    !hostRaw || hostRaw.includes("/") ? SHARED_CONTINUITY_ROOM_PRODUCT_HOST_PRIMARY : hostRaw;
  const path = `/${encodeURIComponent(slug)}`;
  return `${proto}//${safeHost}${path}`;
}
